import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';

// import './DropdownDemo.css';


class Traslate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSeccion: null,
    };
    this.seccionOption = [
      {name: 'About', code: 'about'},
      {name: 'Footer', code: 'footer'},
      {name: 'Detail', code: 'detail'},
      {name: 'User', code: 'user'},
  ];
  }
  
  onCountryChange = (e) =>  {
    this.setState({ selectedSeccion: e.value });
}

selectedCountryTemplate = (option, props) =>  {
      if (option) {
          return (
              <div className="country-item country-item-value">
                  <div>{option.name}</div>
              </div>
          );
      }

      return (
          <span>
              {props.placeholder}
          </span>
      );
  }

  countryOptionTemplate = (option) => (
            <div>{option.name}</div>
    )

render() {
  // const { t } = this.props;
  const { selectedSeccion } = this.state;
  
    const leftContents = (
      <>
        <h5 className="p-mb-0 p-text-capitalize">about</h5>
      </>
    );
    return (
      <div className="p-grid text-demo">
        <div className="p-col-12">
          <div className="card">
            <div className="p-grid">
              <div className="p-col-12 p-md-6 p-lg-6">
                <h4>Traducciones</h4>
              </div>
              <div className="p-col-12 p-md-6 p-lg-6 p-text-right">
                <Dropdown
                  value={selectedSeccion}
                  options={this.seccionOption}
                  onChange={this.onCountryChange}
                  optionLabel="name"
                  filter
                  showClear
                  filterBy="name"
                  placeholder="Seccion"
                  valueTemplate={this.selectedCountryTemplate}
                  itemTemplate={this.countryOptionTemplate}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="p-col-12">
          <div className="card">
            <Toolbar left={leftContents} />
            <div className="p-grid p-mt-1">
              <div className="p-col-12">
                <p className="p-text-bold">title</p>
              </div>
              <div className="p-col-12 p-md-6 p-lg-3">Traduccion A</div>
              <div className="p-col-12 p-md-6 p-lg-3">Traduccion B</div>
              <div className="p-col-12 p-md-6 p-lg-3">Traduccion C</div>
              <div className="p-col-12 p-md-6 p-lg-3">Traduccion D</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {

};

export default compose(
  withTranslation(),
  connect(null, mapDispatchToProps)
)(Traslate);
